<mat-sidenav-container class="sidenav-container">
	<mat-sidenav #sideNav class="sidenav" fixedInViewport
	             [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
	             [mode]="(isHandset$ | async) ? 'over' : 'side'"
	             [opened]="(isHandset$ | async) === false">
		<mat-toolbar>
		<span>
			<img class="logo" src="./assets/img/aon-logo.png" alt="aon-logo"/>
		</span>
		</mat-toolbar>
		<mat-nav-list>
			<mat-list-item *ngFor="let link of links"
			               [routerLink]="link.path"  routerLinkActive="active-link">
				<mat-icon class="fill-remaining-space">{{ link.icon }}</mat-icon>
				<mat-label class="fill-remaining-space">{{ link.label | translate }}</mat-label>
			</mat-list-item>
		</mat-nav-list>
	</mat-sidenav>
	<mat-sidenav-content>
		<mat-toolbar>
			<button
				type="button"
				aria-label="Toggle sidenav"
				mat-icon-button
				(click)="sideNav.toggle()"
				*ngIf="isHandset$ | async">
				<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
			</button>
			<span class="title">{{ 'navbar.title' | translate }}</span>
			<span class="fill-remaining-space"></span>
			<span class="logout">
			<a mat-tab-link class="logout-link" (click)="logout()">
				<mat-icon class="logout-icon">exit_to_app</mat-icon>
				{{ 'navbar.menu.logout' | translate }}</a>
			</span>
		</mat-toolbar>
		<div class="main-content">
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
